import type { SessionUser } from './types/auth';
const tabId = crypto.randomUUID();
const name = 'etnas.session';
type Change = { tabId: string; action: 'signin' | 'signout' | 'lock' | 'activity'; userId?: string; audience?: string; nonce: string; at: number };
export const audienceOf = (user: { kind?: string; audience?: string } | null | undefined) => user?.audience ?? (user?.kind === 'platform' ? 'workforce' : user?.kind);
export function announceSession(action: Change['action'], user?: SessionUser | null) {
  const event: Change = { tabId, action, userId: user?.id, audience: audienceOf(user), nonce: crypto.randomUUID(), at: Date.now() };
  if (typeof BroadcastChannel !== 'undefined') { const channel = new BroadcastChannel(name); channel.postMessage(event); channel.close(); }
  else try { localStorage.setItem(name, JSON.stringify(event)); } catch { /* storage unavailable */ }
}
export function listenSession(listener: (event: Change) => void) {
  const receive = (event: Change) => { if (event && event.tabId !== tabId && ['signin','signout','lock','activity'].includes(event.action)) listener(event); };
  const channel = typeof BroadcastChannel === 'undefined' ? null : new BroadcastChannel(name);
  if (channel) channel.onmessage = e => receive(e.data);
  const storage = (e: StorageEvent) => { if (e.key === name && e.newValue) try { receive(JSON.parse(e.newValue)); } catch { /* invalid event */ } };
  window.addEventListener('storage', storage);
  return () => { channel?.close(); window.removeEventListener('storage', storage); };
}
